/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../utils/config';

export const ENB_SITE_ALLOCATION_URL = `${API_URL}/enbSI`;
